import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Product } from 'src/app/core/_models/product';
import { ProductFormulaService } from 'src/app/core/_services/product.formula.service';

@Component({
  selector: 'app-dialog-complex-product-composition',
  templateUrl: './dialog-complex-product-composition.component.html',
  styleUrls: ['./dialog-complex-product-composition.component.scss']
})
export class DialogComplexProductCompositionComponent implements OnInit {
  currentItem: Product = {};

  constructor(
    public dialogRef: MatDialogRef<DialogComplexProductCompositionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productFormulaService: ProductFormulaService
  ) {}

  ngOnInit(): void {
    this.productFormulaService.getFormulaComposition(this.data.resourceId).subscribe((composition) => {
      this.currentItem.productsComposition = composition;
    });
  }
}
